import * as React from 'react';
export const IcGoForward10 = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19 12a1 1 0 00-1 1 6 6 0 11-6.44-6l-.27.27a1 1 0 00.325 1.64 1 1 0 001.095-.22l2-2a1.001 1.001 0 000-1.42l-2-2a1.003 1.003 0 10-1.42 1.42l.32.31A8 8 0 1020 13a1 1 0 00-1-1zm-5.5-1a1.5 1.5 0 00-1.5 1.5v1a1.5 1.5 0 103 0v-1a1.5 1.5 0 00-1.5-1.5zm.5 2.5a.5.5 0 11-1 0v-1a.5.5 0 011 0v1zM10.5 15a.5.5 0 00.5-.5v-3a.5.5 0 00-.31-.46.47.47 0 00-.54.11l-1 1a.495.495 0 10.7.7l.15-.14v1.79a.5.5 0 00.5.5z'
      fill='currentColor'
    />
  </svg>
);
